import { useEffect, useState } from 'react';
import { getCaseMatter } from 'services/CaseServices';
import { totalCountEvent } from 'services/generalServices';
import Cookies from 'universal-cookie';
const cookie = new Cookies();

export const useCaseMatter = (practice_area = '', options = {}, loadFullList = true, limit = 15, caseMatterValue = null) => {
  const [caseMatterList, setCaseMatterList] = useState([]);
  const tenantId = cookie.get('tenantId') || null;
  const tenant_sk = cookie.get('tenantSk') || null;
  let tenantSk = tenant_sk ? tenant_sk.replace('#', '%23') : '';

  const loadCaseMatter = async () => {
    if (loadFullList) {
      totalCountEvent('case-matter')
        .then((response) => {
          getCaseMatter(tenantId, tenantSk, response.data, '', 'forward', 'alphabet_ascending', practice_area, caseMatterValue)
            .then((res) => setCaseMatterList(res.data?.['case-matter'] || []))
            .catch((error) => console.error(error));
        })
        .catch((err) => console.log(err));
    } else {
      const response = await getCaseMatter(tenantId, tenantSk, limit, '', 'forward', 'alphabet_ascending', practice_area, caseMatterValue);
      setCaseMatterList(response?.data?.['case-matter'] || []);
    }
  };

  useEffect(() => {
    loadCaseMatter();
  }, [practice_area]);

  return { loadCaseMatter, caseMatterList };
};
